import { socket as mainSocket } from "./socketService";

let socket: any;

const connect = (handleConnection: (_: boolean) => void) => {
  socket = mainSocket;
  if (socket) handleConnection(true);
  // socket = io(`${SOCKET_LINK}/v1/event`, {
  //     forceNew: true,
  //     extraHeaders: {
  //         Authorization: authHeader() || '',
  //     }
  // })
  // return new Promise((res, _rej) => {
  //     socket.on('connect', function (socket: any) {
  //         // handleConnection(true)
  //         // setTimeout(()=>{
  //         //     joinUser();
  //         // },500)
  //         res(socket);
  //     });
  //     socket.on('disconnect', function () {
  //         // handleConnection(false)
  //     });
  //     socket.once('connect_error', function () {
  //         console.log("error")
  //     });
  //     socket.once('connect_timeout', function () {
  //     });
  // })
};

const joinEvent = (data: any) => {
  socket?.emit("join-event-room", JSON.stringify(data));
};

const leaveEvent = (data: any) => {
  socket?.emit("event-leave", JSON.stringify(data));
};

const getEventDetails = (setEventData: (arg0: any) => void) => {
  socket?.on("get-event-details", (data: { response_error: any; data: any }) => {
    if (data && !data.response_error && data.data) {
      // console.log(data)
      setEventData(data.data);
    }
  });
};

const joinSport = (data: any) => {
  socket?.emit("join-sport-room", JSON.stringify(data));
};

const leaveSport = (data: any) => {
  socket?.emit("sport-leave", JSON.stringify(data));
};

const getSportDetails = (setSportData: (arg0: any) => void) => {
  socket?.on("get-sport-details", (data: { response_error: any; data: any }) => {
    if (data && !data.response_error && data.data) {
      setSportData(data.data);
    }
  });
};

const getLiveScore = (setLiveScoreData: (arg0: any) => void) => {
  console.log("🚀 ~ getLiveScore ~ arg0:");
  socket?.on("send-live-score-event", (data: { response_error: any; data: any }) => {
    if (data && !data.response_error && data.data) {
      setLiveScoreData(data.data);
    }
  });
};

const chekUserConnected = (connectToRooms = () => {}) => {
  socket?.on("token-verified", (data: any) => {
    if (data.data.isVerified) {
      connectToRooms();
    } else {
      sessionStorage.clear();
      window.location.replace("/");
    }
  });
};

const disconnect = () => {
  socket?.disconnect();
};

const eventSocket = {
  connect,
  joinEvent,
  leaveEvent,
  getEventDetails,
  joinSport,
  leaveSport,
  getSportDetails,
  getLiveScore,
  disconnect,
  chekUserConnected,
};

export default eventSocket;
